// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__8-7To","location":"Header_location__cT4c_"};